import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import FilterListIcon from '@mui/icons-material/FilterList';
import { CustomerTypes } from '../../../types';
import { RootState } from '../../../store';
import FormBuilder from '../../form-builder';
import { CUSTOMER_FILTER_INPUTS } from '../../../builders/customers-builders';

interface Props {
    onFilter(filters: CustomerTypes.Filters): Promise<void>,
}

export const CustomerListFilters: React.FC<Props> = ({ onFilter }) => {
    const [open, setOpen] = useState(false);
    const { loading } = useSelector((state: RootState) => state.customersAdmin);

    const initial =  {
        city: '',
        name: '',
        state: '',
        zip: '',
    } as CustomerTypes.Filters;

    const formik = useFormik<CustomerTypes.Filters>({
        initialValues: { ...initial },
        onSubmit: async (filters) => {
           await onFilter(filters);
        }
    });

    const { 
        errors,
        touched,
        values,
        setFieldValue,
        handleSubmit,
        getFieldProps,
    } = formik;

    return (
        <Box>
            <Accordion
                expanded={open}
                style={{ boxShadow: '0' }}
            >
                <AccordionSummary
                    onClick={() => setOpen(o => !o)}
                    expandIcon={<ExpandMoreIcon />}
                >
                    <FilterListIcon sx={{ mr: 1.5, ml: -1 }} />
                    <Typography fontSize={16} fontWeight={500}>
                        Filters
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Grid container spacing={1}>
                                <Grid item md={12}>
                                    <FormBuilder
                                        errors={errors}
                                        touched={touched}
                                        size="medium"
                                        values={values}
                                        inputs={[...CUSTOMER_FILTER_INPUTS]}
                                        setFieldValue={setFieldValue}
                                        getFieldProps={getFieldProps}
                                    />
                                </Grid>
                            </Grid>
                            <Grid display={'flex'} flexDirection={'row-reverse'} mt={2}>
                                <LoadingButton
                                    variant='contained'
                                    color={'primary'}
                                    loading={loading?.fetchMany}
                                    type={'submit'}
                                >
                                    Search
                                </LoadingButton>
                                <Button
                                    disabled={loading?.fetchMany}
                                    variant='text'
                                    sx={{ mr: 1 }}
                                    color={'inherit'}
                                    onClick={async () => {
                                        formik.setValues({
                                            ...initial
                                        });
                                        await onFilter({} as CustomerTypes.Filters);
                                    }}
                                >
                                    Clear filters
                                </Button>
                            </Grid>
                        </Form>
                    </FormikProvider>
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}